module.exports = __webpack_public_path__ + "media/icons/icon-info-blue-6261f9c3.svg";